
import * as React from 'react';


import './flash-popupwrappercss.css';
import { PopUpWrapperViewImpl } from '../../popupwrapperview';
import { PopUpWrapperComponentProps, PopUpWrapperComponentState } from '../../popupwrappercomponent';
import { PopUpWrapperCSSStyle } from '../../popupwrappercss';

export class FlashPopUpWrapperViewImpl extends PopUpWrapperViewImpl
{
    draw(props: PopUpWrapperComponentProps, state: PopUpWrapperComponentState, cssStyle: PopUpWrapperCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
    
        if(state.isShowWindow)
        {
            return (
                <>
                  <div id="flash-popup-web">
                        {
                            this.getWebView(props, state, cssStyle)
                        }
                  </div>
               
               
                </>);
        }
       else{
           return false;
       }
    }

    getWebView(props: PopUpWrapperComponentProps, state: PopUpWrapperComponentState, cssStyle: PopUpWrapperCSSStyle):JSX.Element
    {
        return(
                <>
                    <div id="flash-nodeA" style={cssStyle.getWrapperCSSStyle()}>
                     <div id="flash-animatetop">
                        <div id="flash-popup-content" style={cssStyle.getContentDivCSSStyle()}>
                            {
                                state.childComponent
                            }
                        </div>
                    </div>   
                    
                 </div>
                </>
        );
    }

    
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashpopup/flashwrapper/flashpopupwrapperview.tsx